import APIClient from '../factories/APIClient'
import generateDeviceId from '../../generateDeviceId'

import attachMock from '../factories/attachMock'
import MOCK_RESPONSES from './HelpCenter.mock.json'

const client = new APIClient({
  baseURL: process.env.REACT_APP_EXPLORE_API_BASE_URL,
})

if (process.env.NODE_ENV === 'development') {
  attachMock(
    client,
    MOCK_RESPONSES,
  )({
    // 'get /admin/faq-subjects': 200,
  })
}

// eslint-disable-next-line import/prefer-default-export
export const getAllFAQ = () => {
  return client({
    method: 'get',
    url: '/faq-subjects',
  })
}
